import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./Slices/user";
import windowsReducer from "./Slices/windowsSlice"; // Webtop window-manager engine (Phase 16)
import desktopLayoutReducer from "./webtop/layout/desktopLayoutSlice"; // Webtop per-user layout (Phase 16)
import webtopUiReducer from "./webtop/webtopUiSlice"; // Webtop shell UI state (built-in apps)
import { webtopBridge } from "./webtop/webtopBridge"; // Webtop: retarget openTab → windows (Phase 16)
import timerReducer from './Slices/timerslice';
import salesSlice from './Slices/salesSlice';
import manualReportsSlice from './Slices/manualReportsSlice';
import getOrders from "./Slices/orderSlice";
import employeeReducer from './Slices/employeeslice';
import clientReducer from './Slices/clientSlice';
import employeeReportReducer from './Slices/employeereportslice';
import getReports from "./Slices/reportSice";
import loaderSlice from "./Slices/loaderSlice";
import loginUserSlice from "./Slices/loginUserSlice";
import DataBucket from "./Slices/dataBucket";
import Route from "./Slices/DyanamicRoute";
import lastContactedDatesSlice from './Slices/lastContactedDatesSlice';
import leavesReducer from "./Slices/LeavesSlice";
import adminLeaveRequest from "./Slices/adminLeaveSlice";
import holidaySlice from "./Slices/holidaySlice";
import attendence from "./Slices/attendenceSlice"
import financeSlice from "./Slices/financeSlice";
import taskSlice from "./Slices/taskSlice"
import clientreducer from './Slices/Thunk/Reports'
import emailRepliesSlice from './Slices/emailRepliesSlice';
// brevoSlice removed — replaced by bulkOutreachSlice
import EmailSocket from './Slices/socketemail'
import emailslice from './Slices/notification'
import reportSlice from './Slices/Thunk/Reports'
import attachmentsSlice from "./Slices/profileAttachmentslice";
import assetSlice from './Slices/assetSlice'
import issuesSlice from './Slices/IssueSlice';
import sharedEmailSlice from './Slices/sharedEmailSlice';
import salesEmailsSlice from './Slices/salesEmailsSlice';
import employeePerformanceReducer from './Slices/employeePerformanceSlice';
import employeesReducer from "./Slices/Thunk/getemployeelist";
import columnSettingsReducer from './Slices/columnSettingsSlice';
import employeesSlice from "./Slices/Thunk/getemployeelist";
import corpMailsSlice from './Slices/corpMailsSlice';
import esslDataSlice from './Slices/esslSlice';
import hiringSlice from './Slices/hiringSlice';
import employeeAccessSlice from './Slices/Employeeaccessslice';
import logger from "redux-logger";
import desktopAccessKeysSlice from './Slices/Thunk/desktopAccesskeyThunk';
import { subscriptionInvoiceReducer } from './Slices/clientSlice';
import invoiceProductsReducer from './Slices/InvoiceSlice';
import aiSalesReducer from './Slices/aiSalesSlice';
import handbookSlice from "./Slices/handBookSlice";
import handbookAccessSlice from "./Slices/handBookAccessSlice";
import tabsReducer from "./Slices/tabSlice";
import chatReducer from "./Slices/chatSlice";
import policyCheckReducer from "./Slices/policyCheckSlice";
import leadReplyNotifsReducer from "./Slices/leadReplyNotifsSlice";
import bulkOutreachReducer from "./Slices/bulkOutreachSlice";
import mailThreadsReducer from "./Slices/mailThreadsSlice";
import mailMessagesReducer from "./Slices/mailMessagesSlice";
import mailFoldersReducer from "./Slices/mailFoldersSlice";
import mailUiReducer from "./Slices/mailUiSlice";
import scheduledMailReducer from "./Slices/scheduledMailSlice";
import payrollReducer from "./Slices/payrollSlice";
import whatsappReducer from "./Slices/whatsappSlice";


const store = configureStore({

  reducer: {
    user: userSlice.reducer,
    timer: timerReducer,
    employee: employeeReducer,
    sales: salesSlice,
    manualReports: manualReportsSlice,
    clients: clientReducer,
    reports: getReports,
    orders: getOrders,
    employeeReports: employeeReportReducer,
    loader: loaderSlice,
    loginUserInfo: loginUserSlice,
    dataBucket: DataBucket,
    Route: Route,
    lastContactedDates: lastContactedDatesSlice,
    leaves: leavesReducer,
    adminLeave: adminLeaveRequest,
    holidayData: holidaySlice,
    Attendence: attendence,
    finance: financeSlice,
    task: taskSlice,
    clientprofile: clientreducer,
    emailReplies: emailRepliesSlice,
    // brevo removed
    emailSocket: EmailSocket,
    EmailData: emailslice,
    Reports: reportSlice,
    Attachments: attachmentsSlice,
    Assets: assetSlice,
    Issues: issuesSlice,
    sharedEmail: sharedEmailSlice,
    salesEmails: salesEmailsSlice,
    employeePerformance: employeePerformanceReducer,
    employees: employeesReducer,
    columnSettings: columnSettingsReducer,
    employees: employeesSlice,
    corpMails: corpMailsSlice,
    esslData: esslDataSlice,
    hiring: hiringSlice,
    employeeAccess:employeeAccessSlice,
    accessKeys: desktopAccessKeysSlice,
    subscriptionInvoice: subscriptionInvoiceReducer,
    invoiceProducts: invoiceProductsReducer,
    aiSales: aiSalesReducer,
    handbooks: handbookSlice,
    handbookAccess: handbookAccessSlice,
    tabs: tabsReducer,
    windows: windowsReducer, // Webtop window-manager engine (Phase 16)
    desktopLayout: desktopLayoutReducer, // Webtop per-user layout (Phase 16)
    webtopUi: webtopUiReducer, // Webtop shell UI state (built-in apps)
    chat: chatReducer,
    policyCheck: policyCheckReducer,
    leadReplyNotifs: leadReplyNotifsReducer,
    bulkOutreach: bulkOutreachReducer,
    // --- Outlook Mail System ---
    mailThreads: mailThreadsReducer,
    mailMessages: mailMessagesReducer,
    mailFolders: mailFoldersReducer,
    mailUi: mailUiReducer,
    scheduledMail: scheduledMailReducer,
    payroll: payrollReducer,
    whatsapp: whatsappReducer, // WhatsApp Business shared inbox
  },
  // webtopBridge retargets tab nav → windows when the Webtop is active (no-op otherwise).
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(webtopBridge),
});
export default store;
